import React from 'react';
import styles from "../../../LocationForm.module.css";
import {ValidationResult} from "../../../../../../../elements/validator/component/ValidationComponent";
import {NotEmptyStringValidator} from "../../../../../../../elements/validator/Validator";
import {
    LocationFormSelectionProvider,
    LocationRequest,
    LocationRequestPartial,
    WorkingHoursRequest
} from "../../../LocationForm";
import {ValidatedInputField} from "../../../../../../../elements/validator/component/ValidatedInputField";

interface Props<T, W> {
    getMessage: (s: any) => any;
    updateRequest: (update: LocationRequestPartial) => void;
    selectionProvider: LocationFormSelectionProvider<W>;
    updateValidationStatus: (status: ValidationResult<T>) => void,
}

export const SpidersnetFileFields = <
    T extends LocationRequest,
    W extends WorkingHoursRequest
>({
      getMessage,
      updateRequest,
      selectionProvider,
      updateValidationStatus
  }: Props<T, W>) => {

    return <div className={styles.fieldsLine}>
        <ValidatedInputField<string, T>
            onChange={(v) => updateRequest({feedId: v})}
            updateValidationStatus={updateValidationStatus}
            fieldName={'feedId'}
            selector={selectionProvider.feedId}
            validator={NotEmptyStringValidator}
            label={'Feed ID'}
            placeholder={"e.g., 1038609"}
            getMessage={getMessage}
        />
    </div>
}
